export const NOTEBOOKURL=process.env.REACT_APP_BASE_URL

